import React from 'react';
import { Text } from '@ui';
import { SelectInput } from '@ui/molecules/inputs';
import { translate } from '@utils/i18n';
import { LEAVE_AS_IS, UNASSIGN } from './types';
const NAMESPACE = 'features.settings.technicians.deactivate_technician';
/**
 * The body of the deactivation dialog: what the technician still holds, and where it should go.
 *
 * Split out from DeactivateTechnician so the parent stays a state-and-submit shell — this part is
 * pure presentation over the props Rails rendered.
 */
export function DeactivateWorkSummary({ counts, destinations, value, onChange, backgroundThreshold }) {
    const total = counts.inspections + counts.workOrders;
    // Each count is pluralised on its own so the mixed case reads properly — "no open inspections
    // and 1 open work order", never "0 open inspections and 1 open work orders".
    const openWork = translate('open_work', {
        namespace: NAMESPACE,
        inspections: translate('inspections', { namespace: NAMESPACE, count: counts.inspections }),
        // Mirrors the %{work_orders} placeholder in the YAML, so it cannot be camelCase.
        // eslint-disable-next-line @typescript-eslint/naming-convention
        work_orders: translate('work_orders', { namespace: NAMESPACE, count: counts.workOrders })
    });
    const options = [
        { value: LEAVE_AS_IS, label: translate('leave_as_is', { namespace: NAMESPACE }) },
        { value: UNASSIGN, label: translate('unassign', { namespace: NAMESPACE }) },
        ...destinations.map((destination) => ({
            value: String(destination.id),
            label: destination.name
        }))
    ];
    return (React.createElement("div", { className: "deactivate-technician__body" },
        React.createElement(Text, { variant: "body" }, openWork),
        React.createElement(SelectInput, { id: "reassign_to", name: "reassign_to", label: translate('destination_label', { namespace: NAMESPACE }), options: options, value: value, onChange: onChange, showSearch: destinations.length > 10, searchPlaceholder: translate('search_placeholder', { namespace: NAMESPACE }) }),
        React.createElement(Text, { variant: "x-small" }, value === LEAVE_AS_IS
            ? translate('leave_as_is_hint', { namespace: NAMESPACE })
            : translate('move_hint', { namespace: NAMESPACE })),
        value !== LEAVE_AS_IS && total > backgroundThreshold && (React.createElement(Text, { variant: "x-small" }, translate('background_hint', { namespace: NAMESPACE, count: total })))));
}
export default DeactivateWorkSummary;
